/**
 * Module dependencies.
 */

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PieChartOutlined,
  FileTextOutlined,
  TranslationOutlined,
  DatabaseOutlined,
  LinkOutlined,
  MedicineBoxOutlined,
  GlobalOutlined,
  QuestionCircleOutlined,
  MessageOutlined
} from '@ant-design/icons';
import { Outlet } from 'react-router-dom';
import { Dashboard } from './dashboard';
import { appRoutes } from 'app/routes';
import { compileMenu } from 'app/core/utils/menu';

/**
 * Export `SkinDeveloper` component.
 */

export function SkinDeveloper(): JSX.Element {
  const [translate] = useTranslation();
  const items = useMemo(
    () =>
      compileMenu([
        {
          key: '1',
          pathname: appRoutes.dashboard.developer.base,
          icon: <PieChartOutlined />,
          label: translate('developer.menu.overview')
        },
        {
          key: 'logs',
          pathname: appRoutes.dashboard.developer.logs,
          icon: <FileTextOutlined />,
          label: translate('developer.menu.logs'),
          children: [
            {
              key: '2',
              pathname: appRoutes.dashboard.developer.logs,
              label: translate('developer.menu.serverLogs'),
              icon: <DatabaseOutlined />
            },
            {
              key: '4',
              pathname: appRoutes.dashboard.developer.ignoreUrlLogs,
              label: translate('developer.menu.ignoreUrlLogs'),
              icon: <LinkOutlined />
            },
            {
              key: '3',
              pathname: appRoutes.dashboard.developer.logsTherapy,
              label: translate('developer.menu.therapyLogs'),
              icon: <MedicineBoxOutlined />
            }
          ]
        },
        {
          key: 'translations',
          pathname: appRoutes.dashboard.developer.translations,
          icon: <TranslationOutlined />,
          label: translate('developer.menu.translationsMenu'),
          children: [
            {
              key: '5',
              pathname: appRoutes.dashboard.developer.translations,
              label: translate('developer.menu.translations'),
              icon: <GlobalOutlined />
            },
            {
              key: '6',
              pathname: appRoutes.dashboard.developer.missingTranslations,
              label: translate('developer.menu.missingTranslations'),
              icon: <QuestionCircleOutlined />
            }
          ]
        },
        {
          key: '7',
          pathname: appRoutes.dashboard.developer.smsTest,
          icon: <MessageOutlined />,
          label: translate('developer.menu.smsTest')
        }
      ]),
    [translate]
  );

  return (
    <Dashboard menu={items}>
      <Outlet />
    </Dashboard>
  );
}
